export default __webpack_public_path__ + "static/media/cookie-preview.8fd1ce6e.svg";